import { render, staticRenderFns } from "./StepContent.vue?vue&type=template&id=afa065e2&scoped=true&"
import script from "./StepContent.vue?vue&type=script&lang=ts&"
export * from "./StepContent.vue?vue&type=script&lang=ts&"
import style0 from "./StepContent.vue?vue&type=style&index=0&id=afa065e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa065e2",
  null
  
)

export default component.exports